import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=199a8f6d&"
import script from "./TheHeader.vue?vue&type=script&defer=true&lang=js&"
export * from "./TheHeader.vue?vue&type=script&defer=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports